// Helper function to get auth headers
export const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    };
}; 